<template>
  <search
    ref="search"
    global
    header
    :source="globalSearchSource"
    :sort="sort"
    :placeholder="placeholder"
    v-bind="$attrs"
    @select="handleSelect"
    @enter="enterSearch"
  >
    <template #header>
      <div class="pills-header">
        <pill
          v-for="(option, i) in sourceOptions"
          :key="i"
          :active="option.value === globalSearchSource"
          @click="globalSearchSource = option.value; focus()"
        >
          <icon :name="option.icon" />
          <span class="pill-text">{{ option.label }}</span>
        </pill>
      </div>
    </template>

    <template #default="slotProps">
      <profile-list-item
        v-if="slotProps.source === 'profiles'"
        :profile="slotProps.item"
      />

      <card-list-item
        v-if="slotProps.source === 'cards'"
        split
        :card="slotProps.item"
        :fields="['pop', 'marketValue', 'currentValue']"
      >
        <verified-icon />
      </card-list-item>

      <shop-list-item
        v-else-if="slotProps.source === 'listings'"
        split
        :item="slotProps.item"
      />

      <sales-list-item
        v-else-if="slotProps.source === 'salesarchive'"
        split
        :item="slotProps.item"
      >
        <verified-icon v-if="slotProps.item.cardId" />
      </sales-list-item>

      <index-list-item
        v-else-if="slotProps.source === 'players'"
        split
        :index="slotProps.item"
        :fields="['totalCards', 'dailySales', 'monthlyPercentChange']"
      />
    </template>
  </search>
</template>

<script>
import ProfileListItem from '@/profiles/ProfileListItem';
import CardListItem from '@cardladder/shared/components/CardListItem';
import ShopListItem from '@cardladder/shared/components/ShopListItem';
import SalesListItem from '@cardladder/shared/components/SalesListItem';
import IndexListItem from '@cardladder/shared/components/IndexListItem';
import VerifiedIcon from '@cardladder/shared/components/VerifiedIcon';
import Search from '@/components/Search';

import { SEARCH_SOURCE_OPTIONS } from '@cardladder/shared/constants';

export default {
  components: {
    ProfileListItem,
    CardListItem,
    ShopListItem,
    SalesListItem,
    IndexListItem,
    VerifiedIcon,
    Search,
  },

  props: {
    placeholder: {
      type: String,
      default: 'Search',
    },
  },

  computed: {
    sourceOptions() {
      return SEARCH_SOURCE_OPTIONS;
    },

    sort() {
      let sortOption = this.sourceOptions.find(({ value }) => value === this.globalSearchSource);

      if (!sortOption) {
        sortOption = this.sourceOptions[0];
      }

      return sortOption.sort;
    },

    globalSearchSource: {
      get() {
        return this.$store.state.globalSearchSource;
      },

      set(value) {
        this.$store.commit('SET_GLOBAL_SEARCH_SOURCE', value);
      },
    },
  },

  methods: {
    focus() {
      this.$refs.search.focus();
    },

    handleSelect(item) {
      if (this.globalSearchSource === 'profiles') {
        this.$router.push(`/profiles/${item.id}`).catch(() => {});
      } else if (this.globalSearchSource === 'cards') {
        if (this.$route.name === 'Card') {
          this.$router.push(`/card/${item.id}`).catch(() => {});
        } else {
          this.$router.push({
            query: {
              cardId: item.id,
            },
          }).catch(() => {});
        }
      } else if (this.globalSearchSource === 'listings') {
        window.open(item.url, '_blank');
      } else if (this.globalSearchSource === 'salesarchive') {
        this.$router.push({
          query: {
            ...this.$route.query,
            saleId: item.id,
            index: item.hitIndex,
          },
        }).catch(() => {});
      } else if (this.globalSearchSource === 'players') {
        this.$router.push(`/players/${item.id}`).catch(() => {});
      }
    },

    enterSearch(query) {
      if (this.globalSearchSource === 'cards') {
        this.$router.replace(`/ladder?q=${encodeURIComponent(query || '')}`).catch(() => {});
      } else if (this.globalSearchSource === 'listings') {
        this.$router.replace(`/shop?query=${encodeURIComponent(query || '')}`).catch(() => {});
      } else if (this.globalSearchSource === 'salesarchive') {
        this.$router.replace(`/sales-history?sort=date&direction=desc&q=${encodeURIComponent(query || '')}`).catch(() => {});
      } else if (this.globalSearchSource === 'players') {
        this.$router.replace(`/players?q=${encodeURIComponent(query || '')}`).catch(() => {});
      } else if (this.globalSearchSource === 'profiles') {
        this.$router.replace(`/profiles?q=${encodeURIComponent(query || '')}`).catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pills-header {
  margin: $gp * .5 0 0 $gp * .5;
  --icon-size: 18px;
}

.pill-text {
  line-height: 1;
  padding-left: 5px;
}
</style>
